import { DatePipe } from "@angular/common";


export class DateUtils {

    // Convert UTC Date to EST/EDT Date
  static convertToEst(utcDate: Date): Date {    
    const offsetHours = this.isInDST(utcDate) ? -4 : -5; // EDT: -4, EST: -5
    const estTime = new Date(utcDate.getTime() + (offsetHours * 60 * 60 * 1000));    
    return estTime;
  }

  // Check if a date is in DST for Eastern Time (America/New_York)
  // acquired this code from GROK
  static isInDST(date: Date): boolean {
    const year = date.getUTCFullYear();
    
    // Approximate DST start: second Sunday in March (2nd month, 0-based)
    const dstStart = new Date(Date.UTC(year, 2, 8)); // March 8
    dstStart.setUTCDate(8 + (7 - dstStart.getUTCDay()) % 7); // Adjust to Sunday
    
    // Approximate DST end: first Sunday in November (10th month, 0-based)
    const dstEnd = new Date(Date.UTC(year, 10, 1)); // November 1
    
    dstEnd.setUTCDate(1 + (7 - dstEnd.getUTCDay()) % 7); // Adjust to Sunday
    return date.getTime() >= dstStart.getTime() && date.getTime() < dstEnd.getTime();
  }

  static readonly longDateFormatter = ((dp) => (dt: Date) => dp.transform(dt, 'M/d/yyyy h:mm a'))(new DatePipe('en-US'));
  
}